module.exports = __webpack_public_path__ + "static/media/W09F2150-WEB5.b4c86c64.svg";